import React, { useEffect } from 'react';
import { compose } from 'ramda';
import queryString from 'query-string';
import Cookies from 'js-cookie';
import api from 'api/api';
import env from 'consts/env';
import AUTH from 'consts/auth';

import StoreProvider from 'components/StoreProvider/StoreProvider';
const { connect, actions } = StoreProvider;

const BexioLogin = ({ location, setLanguage }: any) => {
  const { token } = queryString.parse(location.search);
  const isProduction = env.IS_NODE_ENV_PRODUCTION;
  const domain = isProduction ? '.deeptrue.com' : 'localhost';
  useEffect(() => {
    if (token) {
      api.resources
        .verifyAccount({ token: `${token}` })
        .then(({ data }) => {
          setLanguage(data.user.language);
          Cookies.set(AUTH.TOKEN, `${data.token}`, {
            path: '/',
            domain,
          });
          window.location.replace(`/`);
        })
        .catch(() => {
          window.location.replace(`${env.LANDINGPAGE_URL}/bexio`);
        });
    }
    // eslint-disable-next-line
  }, [token]);
  return <div></div>;
};

export default compose(
  connect(null, {
    setLanguage: actions.intlActions.setLanguage,
  })
)(BexioLogin);
